import { render, staticRenderFns } from "./ChangeOfAveragePriceOverTime.vue?vue&type=template&id=68c33a88"
import script from "./ChangeOfAveragePriceOverTime.vue?vue&type=script&lang=js"
export * from "./ChangeOfAveragePriceOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports